import Config from '../../configuration';
import { isClientSide } from '../environment';

// extract all mock fpaths from configuration
// pass root of mock definition
const mockPathRe = /^(.+.fetch-mock.js).*$/;
export const getMockFilesPathsFromConfig = (mockRootFromConfig = Config.get('useMocks.api')) => {
  const fifo = [mockRootFromConfig];
  const result = [];
  while (fifo.length > 0) {
    const value = fifo.shift();
    if (typeof (value) === 'string') {
      if (!mockPathRe.test(value)) {
        throw new Error(`mocked data filenames must correspond to ${mockPathRe}`);
      }
      // strip off query strings
      result.push(mockPathRe.exec(value)[1]);
    } else if (typeof (value) === 'object') {
      fifo.splice(fifo.length - 1, 0, ...(Object.values(value)));
    } else {
      throw new Error(`Value of mock configuration can be only type of 'string' or 'object', not '${typeof (value)}'!`);
    }
  }

  // remove duplicities
  return Array.from(new Set(result));
};

const fnameRegexp = /\/.*\/(\w*.fetch-mock.js).*/;
export const getReqexpFromFnamesForRequireContext = (arrayOfPaths = getMockFilesPathsFromConfig()) => {
  const regexString = arrayOfPaths.reduce((regex, currentPath) => {
    const match = fnameRegexp.exec(currentPath);
    return `${regex}|${match[1]}`;
  }, '').substring(1);
  return new RegExp(regexString);
};

export const getRequiredContext = () => {
  let context;
  try {
    // args must be given as string literals it is fucked up,
    // and we cannot thus import just needed mocks with getMockFilesPathsFromConfig
    context = require.context('../..', true, /fetch-mock\.js$/);
  } catch (e) {

    if (isClientSide()) {
      throw e;
    }
    // eslint-disable-next-line global-require
    const nodePath = require('path');


    const pathToSrc = nodePath.join(__dirname, '../..');
    const files = getMockFilesPathsFromConfig();
    const importedMocks = files.reduce((result, currentFname) => {
      // eslint-disable-next-line
      result[`.${currentFname}`] = require(nodePath.join(pathToSrc, currentFname));
      return result;
    }, {});

    const proxyHandler = {
      apply: (target, thisArg, [key]) => {
        if (!importedMocks[key]) {
          throw new Error(`We cannot find ${key} module in mocked modules!!!`);
        }
        return importedMocks[key];
      },
      get: (target, propName, receiver) => {
        if (propName === 'keys') {
          return () => Object.keys(importedMocks);
        }
        return importedMocks[propName];
      }
    };

    context = new Proxy(() => {}, proxyHandler);

  }
  return context;
};
